import _ from 'lodash'
import Utils from '../utils.js';
import axios from '../axios.js'
import ContentEditable from '../../common/forms/ContentEditable.vue'
import ImageAuto from "../ui/image_auto.vue";
import CalculsDechets from '@/common/mixins/CalculsDechets.js'
import GraphIp from '@/common/ui/graphIp.vue'
import QuantiteEvaluation from '@/common/ui/quantite_evaluation.vue'

export default {
	mixins: [Utils, CalculsDechets],
	data() {
		return {
			products: [],
			company: this.$store.state.company.company,
			dechet_actif: null,
			mentions: {},
			sort_code: 'nom',
			sort_direction: 'ASC',
		}
	},
	props: ['element'],
	created(){
		var self = this;

		//AS--> Mets en place la navigation dans les déchets
		self.dechets = self.$store.state.ui.dechets

		//AS--> Défini le déchet principal par défaut
		self.dechet_actif = Object.values(self.$store.state.ui.dechets)[0];

		//AS--> Enregistre les déchets 
		this.setDechetsStore()

		//AS--> Mets en place les mentions
		for (var i in self.dechets) {
			self.mentions[self.dechets[i].data.id] = [];
			let liste = self.dechets[i]['fiche'];
			if (liste) {
				let etoiles = 1;
				for (var j in liste) {
					if (liste[j].mention != '') {
						let _etoiles = '';
						for (var k = 1; k <= etoiles; k++) _etoiles += '*';
						etoiles++;
						liste[j].etoiles = _etoiles;
						self.mentions[self.dechets[i].data.id].push(_etoiles + ' ' + liste[j].mention);
					}
				}
			}
		}

		self.unwatch_company_company = self.$store.watch(function() {
			return self.$store.state.company.company
		}, function() {
			//AS--> Mets en place les mentions
			for (var i in self.dechets) {
				self.mentions[i] = [];
				let liste = self.dechets[i]['fiche'];
				if (liste) {
					let etoiles = 1;
					for (var j in liste) {
						if (liste[j].mention != '') {
							let _etoiles = '';
							for (var k = 1; k <= etoiles; k++) _etoiles += '*';
							etoiles++;
							liste[j].etoiles = _etoiles;
							self.mentions[i].push(_etoiles + ' ' + liste[j].mention);
						}
					}
				}
			}
		});
	},
	watch:{
		element: function(after){
			this.$store.commit('UI_SET_COMPANY_DECHETS_API', after.list)
		}
	},
	mounted(){
		this.$store.commit('UI_SET_COMPANY_DECHETS_API', this.element.list);
	},
	methods:{
		setDechetsStore(){
			this.$store.commit('UI_SET_COMPANY_DECHETS_API', this.element.list)	
		},
		set_sort_code(code) {
			let self = this;
			if (self.sort_code == code) {
				self.sort_direction = self.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				self.sort_code = code;
				self.sort_direction = 'ASC';
			}
		},
		getPicto(product){
			// if(product.picto_personnalise) return product.picto_personnalise;
			// let product_picto = this.$store.getters.getDechetField(product.id, 'picto');
			// return product_picto ? product_picto : null;
			// console.log(product);
			return 'api=inex/companies/'+this.$store.state.company.company.id+'/products/'+product.product_id+'/'+product.material_id+'/image'
		},
		getPotentielMeta(product){
			let self = this
			let value = null
			if(product.characteristics.length){
				product.characteristics.forEach(function(product_carac){
					if(product_carac.forme_id == 30){
						value = product.quantity * product_carac.value * 0.0098
					}
				})
			}
			return value
		},
		valCarac(carac, dechet, langue_id){
			let value = '-'

			//AS--> Détermine la langue à afficher
			if(typeof langue_id == 'undefined') langue_id = this.$store.state.ui.langues_ids[this.$store.state.ui.langue]

			if(dechet.characteristics.length && langue_id){

				//AS--> Boucle sur les caractéristiques reçues pour ce déchet 'dechet' pour trouver celle qui correspond à la caractéristique à afficher (carac), et filtre en fonction de la langue
				dechet.characteristics.forEach(function(dechet_carac){
					if(dechet_carac.forme_id == carac.id && dechet_carac.langue_id == langue_id){
						value = dechet_carac.value
					}
				})
			}

			//AS--> Si on n'a pas de valeur dans la langue souhaitée, on regarde si la valeur existe dans la langue fre
			if(value == '-' && langue_id != 1){
				return this.valCarac(carac, dechet, 1)
			}

			return value
		},
	    getIpLabel(dechet) {
			return dechet.ip ? this.$t('ip_label_' + dechet.ip).replace(/\n/g, '<br>') : '';
		},
		openModaleMatiere(dechet){
			// if(this.$store.state.ui.sourcing.modale_matiere){
				this.$store.commit('UI_SET_MATIERE', dechet); 
				this.$store.commit('UI_SET_MODAL', {modal: 'matiere'});
			// }
		},
		getQtyAffiche(dechet){
			return this.numberFormatQty(dechet.quantity, ' ' + this.$store.getters.getDechetField(dechet.material_id, 'unite'))
		},
		getCaracPotentielMethanogene(dechet){
			let value = null
			if(dechet.characteristics.length){
				dechet.characteristics.forEach(function(carac){
					if(carac.forme_id == 30){
						value = carac
					}
				})
			}
			return value
		}
	},
	computed: {
		showDechets(){
			let self = this;
			let show = false;
			if(this.$store.state.ui.content == 'monentreprise') return true
			if(this.company.familles_ids){
				this.company.familles_ids.forEach(function(famille_id){
					_.forEach(self.$store.state.ui.sourcing.familles, function(famille){
						if(famille.id == famille_id && famille.affichage_liste == 1) show = true;
					})
				})
			}
			return show;
		},
		company_dechets() {
			let self = this;

			this.signaler_open    = false;
			this.signaler_merci   = false;
			this.signaler         = {};
			this.signaler_erreurs = {};

			if(!self.$store.state.company.dechets_api || !self.$store.state.company.dechets_api.length) return [];
			
			let dechets = this.$store.state.company.dechets_api

			//AS--> Filtre les déchets liés à la catégorie de déchets principale
			_.remove(dechets, function(dechet) {
				return !self.dechet_actif.all_dechets_ids || !self.dechet_actif.all_dechets_ids.includes(dechet.material_id)
			});

			if (Number.isInteger(self.sort_code) && self.dechet_actif.fiche != undefined && self.dechet_actif.fiche[self.sort_code] != undefined && self.dechet_actif.fiche[self.sort_code].fonctionnement == 'numeric') {
				var defaut = self.sort_direction == 'DESC' ? 99999999999999999999999 : -9999999999999999999999;
			} else {
				var defaut = undefined;
			}

			//AS--> Sort les déchets
			dechets = dechets.sort(function(a, b) {
				let _a = a.material_name
				let _b = b.material_name

				if (self.sort_code == 'ip') {
					_a = a.ip
					_b = b.ip
				}

				if (self.sort_code == 'potentiel_meta') {
					carac_a = this.getCaracPotentielMethanogene(a)
					carac_b = this.getCaracPotentielMethanogene(b)
					_a = carac_a?.value ? a.qty * carac_a.value * 0.0098 : 0
					_b = carac_b?.value ? b.qty * carac_b.value * 0.0098 : 0
				}

				if (self.sort_code == 'quantite') {
					_a = a.quantity
					_b = b.quantity
				}

				if (Number.isInteger(self.sort_code) && self.dechet_actif.fiche != undefined && self.dechet_actif.fiche[self.sort_code] != undefined) {
					_a = typeof a.carac[self.sort_code] == 'undefined' ? defaut : a.carac[self.sort_code];
					_b = typeof b.carac[self.sort_code] == 'undefined' ? defaut : b.carac[self.sort_code];
				}

				if (_a < _b)
					return self.sort_direction == 'DESC' ? -1 : 1;
				if (_a > _b)
					return self.sort_direction == 'DESC' ? 1 : -1;
				return 0
			})

			//AS--> Sépare les déchets correspondants aux filtres des autres
			var _dechets_actif = [];
			var _dechets = [];

			_.forEach(dechets, function(dechet, i) {

				//AS--> Ajout de la description trouvée sur la liste des déchets 
				self.$store.state.ui.dechets_liste.forEach(function(dechet_liste){
					if(dechet_liste.id == dechet.id && dechet_liste.description) dechet.description = dechet_liste.description;
				})
				
				//AS--> Active par défaut le déchet
				dechet.actif = true;



				//AS--> ##########################################
				//AS--> Filtre par déchets
				if (!self.$store.state.filters.filters.all_dechets_ids.includes(dechet.material_id)) {
					dechet.actif = false;
				}



				//AS--> ##########################################
				//AS--> Filtre par quantité individuelle de déchet
				if (self.$store.state.filters.filters.dechet_qty && Array.isArray(self.$store.state.filters.filters.dechet_qty)
					&& (typeof dechet.quantity != 'number' || dechet.quantity < self.$store.state.filters.filters.dechet_qty[0] || dechet.quantity > self.$store.state.filters.filters.dechet_qty[1])) {
					dechet.actif = false;
				}



				//AS--> ##########################################
				//AS--> Filtre par IP de déchet
				if (self.$store.state.filters.filters.pertinance && self.$store.state.filters.filters.pertinance > 1 && (typeof dechet.ip != 'number' || dechet.ip < self.$store.state.filters.filters.pertinance)) {
					dechet.actif = false;
				}



				//AS--> ##########################################
				//AS--> Filtre par caractéristique
				if(self.$store.state.filters.filters.caracteristiques){

					//AS--> Pour chaque caractéristique demandées dans les filtres
					_.forEach(self.$store.state.filters.filters.caracteristiques, function(carac_filtre_value, carac_filtre_id){
						if(self.$store.state.ui.custom_filters[carac_filtre_id]){

							let exist = false
							dechet.characteristics.forEach(function(carac){
								if(carac.forme_id == carac_filtre_id){
									exist = true

									let params = self.$store.state.ui.custom_filters[carac_filtre_id]
									switch(params.fonctionnement){
										case 'numeric':
											if(carac.value < carac_filtre_value[0] || carac.value > carac_filtre_value[1]){
												dechet.actif = false;
											}
											break;
										case 'textuel':
											if(!carac_filtre_value.includes(carac.value)){
												dechet.actif = false;
											}
											break;
									}

								}
							})
							if(!exist){
								dechet.actif = false
							}

						}
					})
				}

				//AS--> Gestion de l'image
				if(!dechet.image){
					dechet.picto       = self.$store.getters.getDechetField(dechet.material_id, 'picto')
					dechet.picto_large = self.$store.getters.getDechetField(dechet.material_id, 'picto_large')
				}

				//AS--> Dispatch
				if (dechet.actif) {
					_dechets_actif.push(dechet);
				} else {
					_dechets.push(dechet);
				}

			})
			return _dechets_actif.concat(_dechets);
		},
		//AS--> N'affiche le Potentiel méthanogène que si une des familles cochées dans les filtres doit afficher la stat générale de Potentiel méthanogène et que cette entreprise est liée à cette famille
		showPotentielMeta(){
			let self  = this;
			let stats = this.$store.state.entreprises.stats_familles;
			let show  = false;
			if(Array.isArray(stats) && stats.length){
				stats.forEach(function(stat){
					if(stat.pvr_meta != undefined && self.company.familles_ids.includes(stat.fid)) show = true;
				})
			}
			return show;
		},
		total_dechets(){
			
			let self  = this;
			let qtys = [];

			if(this.$store.state.company.dechets_api.length){
				this.$store.state.company.dechets_api.forEach(function(dechet){
					qtys.push(dechet.quantity)
				})
			}

			let sum = this.calculSommeQtyDechetsAvecNull(qtys);

			return this.numberFormatQty(sum)
		},
		total_dechets_actifs(){
			
			let self  = this;
			let qtys = [];

			if(this.$store.state.company.dechets_api.length){
				this.$store.state.company.dechets_api.forEach(function(dechet){
					if(dechet.actif) qtys.push(dechet.quantity)
				})
			}

			let sum = this.calculSommeQtyDechetsAvecNull(qtys);

			return this.numberFormatQty(sum)
		},
		hasNoActive(){
			let has = false
			if(this.$store.state.company.dechets_api.length){
				this.$store.state.company.dechets_api.forEach(function(dechet){
					if(!dechet.actif) has = true
				})
			}
			return has
		},
		canEdit(){
			return this.$store.getters.userCanEditCompany('dechets', this.company.id)
		}
	},
	components:{
		ContentEditable,
		ImageAuto,
		GraphIp,
		QuantiteEvaluation
	}
}